import { useNavigationContext } from 'hooks';
import { configurationStore } from 'store';

export const useCentreConfiguration = () => {
  const { centreId } = useNavigationContext();

  const {
    isLoading,
    isFetching,
    data: centreConfiguration,
  } = configurationStore.service.useGetCentreConfigurationQuery(
    { centreId: centreId! },
    {
      skip: centreId === undefined,
    }
  );

  return {
    isIeltsFlexiblePlanningOnCentreEnabled:
      centreConfiguration?.isIeltsFlexiblePlanningEnabled ?? false,
    isUkviFlexiblePlanningOnCentreEnabled:
      centreConfiguration?.isUkviFlexiblePlanningEnabled ?? false,
    districtConfigurations: centreConfiguration?.districtConfigurations ?? [],
    isLoading,
    isFetching,
  };
};
